import { render, staticRenderFns } from "./items-grid-02.vue?vue&type=template&id=0bc895a4&scoped=true&"
import script from "./items-grid-02.vue?vue&type=script&lang=js&"
export * from "./items-grid-02.vue?vue&type=script&lang=js&"
import style0 from "./items-grid-02.vue?vue&type=style&index=0&id=0bc895a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc895a4",
  null
  
)

export default component.exports